import cookie from 'cookie'

import { IS_PROD } from './env'

const TEST_ENV_VISITORS_NAME = 'test-env-visitors'

/**
 * 检查用户是否为测试环境访问者
 * @description 用于判断在生产环境中是否应该跳过某些操作（如数据上报）
 * @returns {boolean} 如果用户访问过测试环境且当前在生产环境，返回 true
 */
export const isTestEnvironmentVisitor = (): boolean => {
  const testEnvVisitors = cookie.parse(document.cookie)[TEST_ENV_VISITORS_NAME]
  // 访问过测试环境的在正式环境不上报
  return Boolean(testEnvVisitors && IS_PROD)
}
